import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { usePopoverHandlers, Popover, PopoverType, PopoverPosition, PopoverHeaderAlign, Image, ImageSize, Box, } from '@as/cotopaxi';
import { HtmlInclude } from '../html-include/HtmlInclude';
const CookiePrivacy = ({ privacyData, logoUrl, isCookiePrivacyOpen, onCookiePrivacyClose, }) => {
    const { handlePopoverOpen, handlePopoverClose } = usePopoverHandlers({
        close: onCookiePrivacyClose,
    });
    useEffect(() => {
        if (isCookiePrivacyOpen) {
            handlePopoverOpen(null, null, true, true);
        }
    }, [handlePopoverOpen, isCookiePrivacyOpen]);
    return (_jsx(Popover, { multi: true, disableClickOutside: true, noAnimation: true, anchorEl: isCookiePrivacyOpen, type: PopoverType.MODAL, position: PopoverPosition.BOTTOM, onClose: handlePopoverClose, headerAlign: PopoverHeaderAlign.CENTER, title: _jsx(Image, { src: logoUrl, size: ImageSize.COOKIE_BRAND_LOGO }), children: _jsx(Box, { mobile: {
                spacing: {
                    paddingLeft: 6,
                    paddingRight: 6,
                    paddingBottom: 2,
                },
            }, tablet: {
                spacing: {
                    paddingLeft: 8,
                    paddingRight: 8,
                },
            }, children: _jsx(HtmlInclude, { htmlFragment: privacyData }) }) }));
};
export default CookiePrivacy;
